import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=2ff9f956&scoped=true&"
import script from "./highlight.vue?vue&type=script&lang=js&"
export * from "./highlight.vue?vue&type=script&lang=js&"
import style0 from "./highlight.vue?vue&type=style&index=0&id=2ff9f956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9f956",
  null
  
)

export default component.exports